<template>
  <a-card class="m-t-10" :bordered="false">
    <a-button size="small" @click="() => { $router.go(-1) }">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title" v-if="$route.query.type == 'look'">红包详情</span>
    <span class="ml15 card_title" v-else>{{ $route.query.type == 'add' ? '添加' : '修改' }}红包</span>
  </a-card>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 15 }">
      <a-form-item ref="bonus_type" label="红包类型" name="bonus_type" >
        <a-radio-group name="radioGroup" v-model:value="form.bonus_type" :disabled="$route.query.type == 'edit'">
          <a-radio :value="1">微信红包</a-radio>
          <a-radio :value="2">企业零钱红包</a-radio>
          <a-radio :value="4">小程序红包</a-radio>
          <a-radio :value="3">累计红包</a-radio>
        </a-radio-group>
        <div class="ant-form-explain" v-html="bonus_type_tips[form.bonus_type-1]"></div>
      </a-form-item>
      <a-form-item ref="amount" label="红包金额" name="amount">
        <a-input-number class="width50 m-r-10" v-model:value="form.amount" style="width:200px"  placeholder="请输入红包金额"  :disabled="$route.query.type == 'edit'"/>元
      </a-form-item>
      <a-form-item ref="author" label="发放者" name="author" v-if="form.bonus_type == 1">
        <a-textarea v-model:value="form.author" placeholder="请输入红包发放者" auto-size style="width:200px" />
      </a-form-item>
      <a-form-item ref="description" label="红包说明" name="description">
        <a-textarea v-model:value="form.description" placeholder="请输入红包说明" auto-size style="width:200px"/>
      </a-form-item>
      <a-form-item ref="use_description" label="使用说明" >
        <a-textarea v-model:value="form.use_description" placeholder="请输入使用说明" auto-size  style="width:200px"/>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 3 }" v-if="$route.query.type != 'look'">
        <a-button type="primary" @click="onSubmit">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { reactive, toRefs, ref } from "@vue/reactivity";
import { createBonus, getBonusDetail, editBonus } from "@/api/red";
import { inject, onMounted } from "@vue/runtime-core";
import { iscode } from "../../../../utils/app";
import { LeftOutlined } from "@ant-design/icons-vue";
export default {
  components: { LeftOutlined },
  setup() {
    const state = reactive({
      form: {
        description: "",
        use_description: "",
        bonus_type: 1,
        amount: null,
        author: "",
  
      },
       bonus_type_tips:[
          "1.由公众号推送红包，用户需点击红包领取，领取后才能到用户微信零钱账户。<br/>2.该类型红包只能用于普通二维码扫码活动或会员生日权益红包。<br/>3.红包金额不能低于0.3元，否则无法发放",
          "1.发放后，红包金额直接到用户微信零钱账户，用户不需要领取操作。<br/>2.此类型红包只能用于普通扫码活动",
           "1.此红包扣除账号余额中的金额<br/>2.红包可设置低于0.3元金额，累计金额达到0.3元，发放用户累计的全部金额，用户无需领取操作<br/>3.所有累计金额红包共用一个累计红包池，领取的红包金额将会累积，达到0.3元时自动发放<br/>4.此类型红包不能用于小程序码扫码活动",
          "该类型红包只能用于小程序码扫码活动发放，用户需点击红包领取",
        ],
      rules: {},
    });
    const ruleForm = ref();
    const rules = {
      amount: [{ required: true, message: "请输入红包金额", type: "number" }],
      description: [{ required: true, message: "请输入红包说明" }],
      author: [{ required: true, message: "请输入发放者" }],
    };
    const $route = inject("$route");
    const $router = inject("$router");
    const $Modal =inject('$Modal')
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
   
          var result;
          if ($route.query.type == "add") {
              $Modal.confirm({
                  centered:true,
                  title:'确定生成红包',
                  content: `生成后红包类型和金额不可修改`,
                  onOk:async () => {
                    result = await createBonus(state.form)
                    .then((res) => res.data)
                    .catch((error) => error);
                     if (iscode(result, true)) {
                      $router.go(-1);
                    }
                  },
                  cancel:()=>{
                    return false
                  }
            })
          } else {
            result = await editBonus(state.form)
              .then((res) => res.data)
              .catch((error) => error);
          }
          if (iscode(result, true)) {
            $router.go(-1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    onMounted(async () => {
      if ($route.query.type != "add") {
        // 获取详情
        let result = await getBonusDetail({ id: $route.query.id })
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result)) {
          state.form = result.data;
          state.form.amount = Number(state.form.amount);
        }
      }
    });
    return {
      ...toRefs(state),
      rules,
      onSubmit,
      ruleForm,
    };
  },
};
</script>